export const ROOT = "/register";
export const SUPPLIER = ROOT + "/supplier/:tenderId/:email";
export const SENSABILL = ROOT + "/sensabill";
export const NOT_FOUND = ROOT + "/*";
